import { render, staticRenderFns } from "./Carruselimg.vue?vue&type=template&id=693b04a4&scoped=true"
import script from "./Carruselimg.vue?vue&type=script&lang=js"
export * from "./Carruselimg.vue?vue&type=script&lang=js"
import style0 from "./Carruselimg.vue?vue&type=style&index=0&id=693b04a4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "693b04a4",
  null
  
)

export default component.exports